import { initWidget } from './widget';
import endpoints from './widget/define/endpoints';

import BookingForm from './widget/component/BookingForm';
import AddToWishList from './widget/component/AddToWishList';
import Share from './widget/component/Share';
import Slideshow from './widget/component/Slideshow/Slideshow';
import AddToHistory from './widget/component/AddToHistory';
import Tooltip from './widget/component/Tooltip';
import Avatar from './widget/component/Avatar/Avatar';
import Reviews from './widget/component/Reviews';
import RelatedListings from './widget/component/RelatedListings';
import { ToggleTruncate } from './widget/component/FilterResults/components/ToggleTruncate';
import { Rating } from './widget/component/FilterResults/components/Rating';
import ModalDrawer from './widget/component/modals/ModalDrawer';
import ActiveText from './widget/component/modals/ActiveText';
import { ShowVoucherPreview } from './widget/component/common/ShowVoucherPreview';
import CoverSwiper from './widget/component/CoverSwiper/CoverSwiper';
import { ShowLegalInfo } from './widget/component/common/ShowLegalInfo';
import { CucaSupportButton } from './widget/component/CucaSupportButton';

const initInsertionPageWidgets = () => {
  const props = {
    endpoints,
  };

  initWidget('share', Share, props);
  initWidget('add-to-wish-list', AddToWishList, props);
  initWidget('slide-show', Slideshow, props);
  initWidget('add-to-history', AddToHistory, props);
  initWidget('booking-form', BookingForm, props);
  initWidget('tooltip', Tooltip, props);
  initWidget('avatar', Avatar, props);
  initWidget('reviews', Reviews, props);
  initWidget('related-listings', RelatedListings, props);
  initWidget('toggle-truncate', ToggleTruncate, props);
  initWidget('rating', Rating, props);
  initWidget('modal-drawer', ModalDrawer, props);
  initWidget('active-text', ActiveText, props);
  initWidget('show-voucher-preview', ShowVoucherPreview, props);
  initWidget('cover-swiper', CoverSwiper, props);
  initWidget('show-legal-info', ShowLegalInfo, props);
  initWidget('cuca-support-button', CucaSupportButton, props);
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initInsertionPageWidgets.bind(this)
  );
} else {
  initInsertionPageWidgets();
}
